import React from 'react';
import { FlexLayout } from '../flex/FlexLayout.component';
import { FlexItem } from '../flex/FlexItem.component';
import { FlexLayoutModifier } from '../flex/flex.constants';

export const CompleteBannerHomePage = (): JSX.Element => {
  return (
    <div className="c-ssa-remediation-complete-box c-ssa-remediation-complete-box--dark">
      <FlexLayout modifiers={[FlexLayoutModifier.GUTTERS]}>
        <FlexItem>
          <div className="u-els-font-size-h2">
            <span role="img" aria-label="party popper">&#127881;</span>
          </div>
        </FlexItem>
        <FlexItem modifiers={[FlexLayoutModifier.GROW]}>
          <div>
            <h3 className="u-els-font-family-bold">Congratulations! All required work for your plan is complete!</h3>
            <p>You may review any additional content if you would like.</p>
          </div>
        </FlexItem>
      </FlexLayout>


    </div>
  )
}
